import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import SourceFilter from './SourceFilter';
import ResultsTable from './ResultsTable';
import SearchForm from './SearchForm';

const Home = () => (
  <>
    <Container>
      <SearchForm />
    </Container>
    <Container fluid className="mt-3">
      <Row>
        <Col xs={12} lg={3}>
          <SourceFilter />
        </Col>
        <Col xs={12} lg={9}>
          <ResultsTable />
        </Col>
      </Row>
    </Container>
  </>
);

export default Home;
